// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "sale-of-services div.frame {\n  overflow: auto;\n  max-height: 500px;\n  min-height: 500px;\n  border: 1px solid #a9a9a9;\n}", ""]);
// Exports
module.exports = exports;
